import {
  TranslationService,
  ResourceProvider,
  HttpService,
} from "@sportal/api";

export const makeTranslationService = (http: HttpService): TranslationService =>
  new TranslationService(new ResourceProvider(http));
